import React, { Component } from "react";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import { CaseManagementStore, ChangeTab, ShowNotice } from "Store";
import { mutationAssignCaseToAgent, getMe } from "Apollo";
import AssignButtonView from "./AssignButtonView";

export default graphql(mutationAssignCaseToAgent)(
  observer(
    class AssignButton extends Component {
      render() {
        return (
          <AssignButtonView onClick={this.onAssignToOther}>
            {this.props.children}
          </AssignButtonView>
        );
      }

      onAssignToOther = async () => {
        const me = getMe();
        try {
          await this.props.mutate({
            variables: {
              case: {
                id: CaseManagementStore.selectedCase.id
              },
              agent: {
                id: me.agent.id
              }
            }
          });
          ShowNotice("case-assign-me-success");
        } catch (error) {
          ShowNotice("case-assign-me-error");
        }
        ChangeTab("my");
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/assign-button/AssignButtonWithStoreMutation.js